<template>
    <div id="aqt_content">
      <div class="content_item">
        <div class="line line1"></div>
        <p class="title title_size1">{{aqt.title}}</p>
        <img :src="aqt.img1" class="img_one"/>
        <p class="title  title_size2">{{aqt.describe}}</p>
      </div>
      <div class="content_item">
        <div class="line line2"></div>
        <p class="title title_size1">{{aqt_msg.serve}}</p>
        <p class="title  title_size2">{{aqt_msg.serve_describe}}</p>
        <img :src="aqt_msg.serve_img" class="img_two"/>
        <div class="line line3"></div>
        <p class="title title_size3">{{aqt_msg.serve_offer}}</p>
          <div class="content_item_list" v-for="(list,index) in aqtArr" :key="index">
            <img :src="list.img" class="img_three"/>
            <div class="line line3"></div>
            <p class="title title_size1">{{list.title}}</p>
            <p class="title1 title_size2">{{list.describe}}</p>
          </div>
      </div>
      <div class="content_item" v-for="(list,index) in aqtArr2" :key="index" >
        <div class="line line2"></div>
        <p class="title title_size1">{{list.title1}}</p>
        <p class="title1  title_size2">{{list.title2}}</p>
        <img :src="list.img" class="img_two"/>

      </div>

    </div>

</template>

<script>

    export default {

      data(){
        return{
          aqt:{
            title:'强大的阿启泰团队，为您提供多语言数字化+ AI智能+大数据一体化互联网解决方案。',
            img1:require('../../assets/img/index1.png'),
            describe:'阿启泰自创立以来，深耕IT领域，为客户打造有竞争力、安全可靠、可落地的产品方案与技术服务。厚积薄发，逐梦同行。'
          },
          aqt_msg:{
            serve:'阿启泰服务',
            serve_describe:'我们深度对接需求，量身定制专属解决方案，为您的数字化转型全面赋能。',
            serve_img:require('../../assets/img/index2.png'),
            serve_offer:'阿启泰团队，为您提供'
          },
          aqtArr:[
            {
              img:require('../../assets/img/index3.png'),
              title:'多语言APP /小程序开发',
              describe:'一站式多语言应用开发，兼容多端适配、流畅交互与体验',

            },
            {
              img:require('../../assets/img/index4.png'),
              title:'大数据平台建设',
              describe:'搭建安全、高效、可扩展的数据中台，实现数据汇聚、治理与价值挖掘',

            },
            {
              img:require('../../assets/img/index5.png'),
              title:'多语言系统架构',
              describe:'专业多语言技术架构设计，保障系统稳定、语言切换无感知',

            },
            {
              img:require('../../assets/img/index6.png'),
              title:'多语言数字化建设',
              describe:'全链路多语言数字化升级，覆盖内容、服务、管理全流程',

            },
            {
              img:require('../../assets/img/index7.png'),
              title:'多语言网站、公众号二次开发',
              describe:'多语言前端优化、功能迭代、体验升级，适配政务/企业/媒体场景',

            },

            {
              img:require('../../assets/img/index8.png'),
              title:'AI智能服务',
              describe:'多语言智能检索引擎，支持语义理解、精准匹配、快速定位，大幅提升信息获取效率',

            },
            {
              img:require('../../assets/img/index8.png'),
              title:'AI智慧阅读服务',
              describe:'AI 驱动多语言智能解析、语音朗读、内容摘要、重点提取，实现轻量化、高效化阅读',

            },
            {
              img:require('../../assets/img/index8.png'),
              title:'文化艺术大数据服务',
              describe:'构建文化艺术大数据体系，提供数据整合、加工、存储、检索与智能应用服务',

            },
          ],
          aqtArr2:[
            {
              title1:'阿启泰团队',
              title2:'阿启泰科技自2016年创立以来，坚守 “感恩、效率、进步、责任” 的核心价值观，以技术创新为核心引擎，深耕智慧图书馆与文化艺术资源数字化建设领域。公司现已拥有25项软件著作权，获评诚信达标企业及多项企业等级认证；先后于2022年、2025年连续通过高新技术企业认定，并在2022年荣获内蒙古自治区工业和信息化厅认定的内蒙古自治区首版次软件产品认定等多项权威资质与荣誉，致力于为客户提供安全、高效、值得信赖的全场景技术服务与数字化解决方案。',
              img:require('../../assets/img/index9.png'),

            },
            {
              title1:'阿启泰团队服务于各类行业',

              img:require('../../assets/img/index15.png'),

            }
          ]
        }
      },

      mounted(){

      }
    }
</script>

<style>
  #aqt_content{
    padding-top:4rem;
  }
  .content_item{
    width:90%;
    height:auto;
    margin-left:5%;
    position:relative;
  }
  .line{
    margin: 0 auto;
    width: 10%;
    height: 0.1rem;
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .line1{
    background-color: #F5A623;
  }
  .title{
    margin-left: 3rem;
    margin-right: 3rem;
    text-align:center;
    letter-spacing: 0.1rem;
  }
  .title_size1{
    font-size:1rem;
    color:#F4FAFF;
  }
  .img_one {
    width: 98%;
    margin-left: 1%;
    margin-top: 2rem;

    margin-bottom: 2rem;
  }
  .title_size2{
    font-size: 0.8rem;
    color:#D3DFFF;
    line-height:1.2rem;
    marign-top:1rem;
    margin-top: 1rem;
  }
  .line2{
    background-color:#26BFB9;
  }
  .img_two{
    width:74%;
    margin-top:1rem;
    margin-left:14%;
    margin-bottom:1rem;
  }
  .line3{
    background-color:#D03402;
  }
  .title_size3{
    color:#F4FAFF;
    font-size:1rem;

  }
  .img_three{
    width: 36%;
    margin-left: 32%;
    margin-top: 2rem;
  }


  .title1{
    margin-left: 0.5rem;
    letter-spacing:0.1rem;
    text-align: center;
  }


</style>
